export { default } from './LogoZapierPlatform';
